import React from 'react';
import { Button } from '../components/UI/Button';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe, Award, Clock, Check, AlertTriangle, MessageSquare } from 'lucide-react';
export const Membership = () => {
  return <div className="pt-20 bg-white" data-id="element-3762">
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3763">
        <div className="absolute inset-0 z-0" data-id="element-3764">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3765" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3766"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3767">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3768">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3769">
              LIMITED TIME OFFER
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3770">
              The Inner Circle Membership
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3771">
              Join The Networking Salon Inner Circle — a curated community of
              ambitious professionals. Build meaningful relationships, polish
              your ideas, and unlock opportunities.
            </p>
            <Button className="text-lg px-8 py-4" data-id="element-3772">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Announcement Section */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3773">
        <div className="container mx-auto px-4" data-id="element-3774">
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8 text-center" data-id="element-3775">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-3776">
              Special Founder's Offer
            </h2>
            <div className="flex flex-col md:flex-row justify-center gap-8 mb-6" data-id="element-3777">
              <div data-id="element-3778">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3779">Regular Price:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3780">₦50,000/year</p>
              </div>
              <div className="md:border-l md:border-gray-300 md:pl-8" data-id="element-3781">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3782">Founder's Offer:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3783">₦20,000/year</p>
                <p className="text-gray-600 italic" data-id="element-3784">(until Dec 31 only)</p>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-3785">
              <p className="text-gray-700" data-id="element-3786">
                Subscriptions officially begin Jan 1, 2025 — join now and get
                December free.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3787">
        <div className="container mx-auto px-4" data-id="element-3788">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3789">
            Membership Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-3790">
            {[{
            title: 'Mastermind Sessions',
            description: 'Live idea feedback & strategy polishing',
            icon: <Lightbulb size={24} data-id="element-3791" />
          }, {
            title: 'Project Handholding',
            description: 'Step-by-step guidance',
            icon: <Users size={24} data-id="element-3792" />
          }, {
            title: 'AI Tools Catalogue',
            description: 'Curated tools + playbooks',
            icon: <Bot size={24} data-id="element-3793" />
          }, {
            title: 'Virtual Networking Salons',
            description: 'Free & unlimited for members',
            icon: <Video size={24} data-id="element-3794" />
          }, {
            title: 'Discounted Access to Live Events',
            description: 'Special pricing for Inner Circle members',
            icon: <Calendar size={24} data-id="element-3795" />
          }, {
            title: 'Exclusive Resource Hub',
            description: 'Templates & toolkits',
            icon: <FileText size={24} data-id="element-3796" />
          }, {
            title: 'Mentorship & Expert Access',
            description: 'Group coaching & hot-seat sessions',
            icon: <UserPlus size={24} data-id="element-3797" />
          }, {
            title: 'Visibility & Collaboration Opportunities',
            description: 'Connect with other members',
            icon: <Globe size={24} data-id="element-3798" />
          }].map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3799">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3800">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3801">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-3802">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Community Structure */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3803">
        <div className="container mx-auto px-4" data-id="element-3804">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3805">
            Event & Community Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3806">
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3807">
              <div className="flex items-center mb-4" data-id="element-3808">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3809">
                  <MessageSquare size={24} data-id="element-3810" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3811">
                  WhatsApp Groups
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3812">
                <p className="text-gray-600 mb-4" data-id="element-3813">
                  Reserved exclusively for physical event attendees only.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3814">
                  <li data-id="element-3815">Event-specific discussions</li>
                  <li data-id="element-3816">Limited-time access</li>
                  <li data-id="element-3817">City-based connections</li>
                </ul>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3818">
              <div className="flex items-center mb-4" data-id="element-3819">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3820">
                  <Users size={24} data-id="element-3821" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3822">
                  Inner Circle Membership
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3823">
                <p className="text-gray-600 mb-4" data-id="element-3824">
                  Ongoing access to our premium community resources.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3825">
                  <li data-id="element-3826">Regular masterminds</li>
                  <li data-id="element-3827">Virtual salons</li>
                  <li data-id="element-3828">Exclusive resources</li>
                  <li data-id="element-3829">Ongoing opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lifetime Access */}
      <section className="py-16 border-b border-gray-200" data-id="element-3830">
        <div className="container mx-auto px-4" data-id="element-3831">
          <div className="max-w-3xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3832">
            <div className="flex items-center justify-center mb-6" data-id="element-3833">
              <Award size={36} className="text-gray-700 mr-3" data-id="element-3834" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-3835">
                Lifetime Access Notice
              </h2>
            </div>
            <p className="text-gray-600 text-lg text-center mb-6" data-id="element-3836">
              As a thank-you, everyone who has ever paid for past Networking
              Salon events now has Lifetime Inner Circle Access — which includes
              all membership benefits (masterminds, resources, AI tools, and
              virtual salons).
            </p>
            <div className="flex items-start bg-gray-100 p-4 rounded-lg border border-gray-300" data-id="element-3837">
              <AlertTriangle size={24} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3838" />
              <p className="text-gray-700" data-id="element-3839">
                <span className="font-bold" data-id="element-3840">Clarification:</span> Lifetime
                Access does not include free entry to Live physical events.
                Tickets must still be purchased separately.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3841">
        <div className="container mx-auto px-4" data-id="element-3842">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3843">
            Choose Your Membership
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3844">
            {/* Lifetime Inner Circle Access */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3845">
              <div className="absolute top-0 right-0 bg-gray-800 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3846">
                EXCLUSIVE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3847">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3848">
                  <Award size={32} className="text-gray-700" data-id="element-3849" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3850">
                Lifetime Inner Circle Access
              </h3>
              <p className="text-center text-gray-600 mb-6" data-id="element-3851">
                💎 Exclusive for Past Event Attendees
              </p>
              <div className="border-t border-b border-gray-300 py-4 mb-6" data-id="element-3852">
                <p className="text-center text-gray-700 font-medium" data-id="element-3853">
                  One-time gift for loyalty
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3854">
                <li className="flex items-start" data-id="element-3855">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3856" />
                  <span className="text-gray-600" data-id="element-3857">
                    All Inner Circle membership benefits
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3858">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3859" />
                  <span className="text-gray-600" data-id="element-3860">Masterminds & resources</span>
                </li>
                <li className="flex items-start" data-id="element-3861">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3862" />
                  <span className="text-gray-600" data-id="element-3863">
                    AI tools & virtual salons
                  </span>
                </li>
                <li className="flex items-start text-gray-700 bg-gray-100 p-2 rounded" data-id="element-3864">
                  <AlertTriangle size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3865" />
                  <span data-id="element-3866">
                    Does NOT include free entry to Live physical events
                  </span>
                </li>
              </ul>
              <div className="bg-gray-200 text-center p-3 rounded-lg mb-6" data-id="element-3867">
                <span className="font-bold text-gray-700" data-id="element-3868">
                  You're Already In!
                </span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-3869">
                Already a Lifetime Member? Claim Your Access
              </Button>
            </div>
            {/* Founder's Offer */}
            <div className="border-2 border-gray-700 rounded-lg p-8 relative scale-105 shadow-lg" data-id="element-3870">
              <div className="absolute -top-4 -right-4 bg-gray-800 text-white px-4 py-2 text-sm font-bold rounded-lg transform rotate-6" data-id="element-3871">
                BEST VALUE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3872">
                <div className="w-16 h-16 border-2 border-gray-700 rounded-full flex items-center justify-center" data-id="element-3873">
                  <Clock size={32} className="text-gray-700" data-id="element-3874" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3875">
                Founder's Offer
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-3876">
                🔥 Available Until Dec 31, 2024
              </p>
              <div className="text-center mb-6" data-id="element-3877">
                <p className="text-3xl font-bold text-gray-800" data-id="element-3878">₦20,000</p>
                <p className="text-gray-600" data-id="element-3879">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3880">
                <li className="flex items-start" data-id="element-3881">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3882" />
                  <span className="text-gray-600" data-id="element-3883">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3884">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3885" />
                  <span className="text-gray-600" data-id="element-3886">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3887">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3888" />
                  <span className="text-gray-600" data-id="element-3889">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3890">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3891" />
                  <span className="text-gray-600" data-id="element-3892">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-3893">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3894" />
                  <span className="text-gray-600" data-id="element-3895">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6" data-id="element-3896">
                <span className="font-medium text-gray-700" data-id="element-3897">
                  Bonus: Subscription officially starts Jan 1, 2025 (December
                  free!)
                </span>
              </div>
              <Button className="w-full" data-id="element-3898">Join Now at ₦20,000</Button>
            </div>
            {/* Standard Membership */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3899">
              <div className="absolute top-0 right-0 bg-gray-600 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3900">
                REGULAR PRICE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3901">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3902">
                  <Users size={32} className="text-gray-700" data-id="element-3903" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3904">
                Standard Membership
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-3905">
                📌 From Jan 1, 2025
              </p>
              <div className="text-center mb-6" data-id="element-3906">
                <p className="text-3xl font-bold text-gray-800" data-id="element-3907">₦50,000</p>
                <p className="text-gray-600" data-id="element-3908">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3909">
                <li className="flex items-start" data-id="element-3910">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3911" />
                  <span className="text-gray-600" data-id="element-3912">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3913">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3914" />
                  <span className="text-gray-600" data-id="element-3915">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3916">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3917" />
                  <span className="text-gray-600" data-id="element-3918">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3919">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3920" />
                  <span className="text-gray-600" data-id="element-3921">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-3922">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3923" />
                  <span className="text-gray-600" data-id="element-3924">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6 invisible" data-id="element-3925">
                <span data-id="element-3926">Spacer</span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-3927">
                Join for ₦50,000
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gray-50" data-id="element-3928">
        <div className="container mx-auto px-4 text-center" data-id="element-3929">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-3930">
            Stop Collecting Contacts. Start Building Connections That Change
            Your Future.
          </h2>
          <Button className="text-lg px-8 py-4" data-id="element-3931">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
          <p className="mt-6 text-gray-600" data-id="element-3932">
            Offer ends December 31, 2024. Regular price ₦50,000/year from
            January 1, 2025.
          </p>
        </div>
      </section>
    </div>;
};